import { Button, FormField, Modal, Select, Variants } from "@sede-x/shell-ds-react-framework";
import { Controller, useForm } from "react-hook-form";

import { CIQOption, TCICustomer, TCustomerFilter } from "../carbonIQtypes";

const CustomerLookup = ({
  onClose,
  onSubmit,
  customerData
}: {
  onClose: () => void;
  onSubmit: (data: TCustomerFilter) => void;
  customerData: TCICustomer[];
}) => {
  const customersList = customerData.map(cust => ({
    value: cust.id.toString(),
    label: cust.displayName,
    id: cust.id,
    key: cust.id.toString()
  }));
  const { control, handleSubmit, watch } = useForm<{ customers: CIQOption[] }>();

  const selectedCustomer = watch("customers");

  const onFormSubmit = (data: { customers: CIQOption[] }) => {
    onSubmit({
      customerIDs: data.customers
    });
  };

  return (
    <Modal
      title="Search for Customer(s)"
      width={"700px"}
      height={"600px"}
      mask={true}
      open={true}
      maskClosable={false}
      onClose={onClose}>
      <form onSubmit={handleSubmit(onFormSubmit)}>
        <FormField size={"medium"} id="customer-name" label="Customer Name">
          <Controller
            control={control}
            name="customers"
            render={({ field }) => (
              <Select
                options={customersList}
                size="medium"
                id="customer-name"
                placeholder="Name, ID"
                optionLabelProp="label"
                fieldNames={{ label: "label", value: "value" }}
                value={Array.isArray(field.value) ? field.value.map(v => v.value) : []}
                onChange={(_, selectedOptions) => field.onChange(selectedOptions)}
                onClear={() => field.onChange([])}
                filterOption={true}
                optionFilterProp="label"
                mode="multiple"
                showSearch={true}
              />
            )}
          />
        </FormField>
        <div style={{ paddingBottom: "200px" }}></div>
        <div className="from-button-wrap">
          <Button variant={Variants.Outlined} onClick={onClose}>
            Cancel
          </Button>
          <Button disabled={!selectedCustomer?.length} type="submit">
            Search
          </Button>
        </div>
      </form>
    </Modal>
  );
};

export default CustomerLookup;
